
export default {
	name: 'ICard',
	props: {
		cardImg: {
			type: String,
			default: '',
			required: true
		},
		cardName: {
			type: String,
			default: '',
		},
		cardAge: {
			type: Number,
			default: null,
		},
		cardStatus: {
			type: Boolean,
			default: false,
		}
  },
	data() {
    return {
			isActive: false,
    }
  },
}